import React, { useContext, useEffect, useState } from "react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { no_img } from "../../../../assets";
import { AppContext } from "../../../../App";
import { action, API, controller } from "../../../../api/api";
import {
  getTimeDifference,
  lsGet,
  RandomCode,
  ToFormData,
} from "../../../../hooks/Method";
import { ReplayRounded } from "@mui/icons-material";
import { CartContext } from "../POS";

const RetrieveSales = ({ setRetrieveEl }) => {
  const activeReg = lsGet("activeReg");
  const [sales, setSales] = useState([]);
  const { setCartData } = useContext(CartContext);
  const { authUser, setLoader } = useContext(AppContext);

  useEffect(() => {
    if (authUser && activeReg) {
      setLoader(true);
      API(controller.ParkSale + action.GetAllByOutlet).getById(
        activeReg.outletId,
        (res) => {
          if (res.status === 200) setSales([...res.result]);
          setLoader(false);
        }
      );
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleRetrieve = (id) => {
    if (id) {
      setRetrieveEl && setRetrieveEl(null);

      const onComplete = (res) => {
        setLoader(false);
        if (res && res.status === 200) {
          var _parkDetails = res.result;
          setCartData((j) => ({
            ...j,
            sellItems: _parkDetails.parkItems.map((item, ind) => ({
              ...item,
              key: RandomCode(14) + ind,
            })),
            note: _parkDetails.note || "",
            discount: _parkDetails.discount || "",
            disType: _parkDetails.disType || "",
            customerId: _parkDetails.customerId || "",
            sellRegId: _parkDetails.sellRegId || "",
            outletId: _parkDetails.outletId || "",
            disAmt: _parkDetails.disAmt,
            taxId: _parkDetails.taxId,
          }));
        }
      };

      setLoader(true);
      API(controller.ParkSale + action.Retrieve).post(
        ToFormData({
          id: id,
          retrieveDate: new Date().toLocaleString(),
        }),
        onComplete
      );
    }
  };

  return (
    <div className="pt-[5px] pb-[7px]">
      {sales.length > 0 ? (
        <TableContainer className="max-h-[450px]">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className="!p-[7px] !pl-[15px] min-w-[320px]">
                  <span className="font-bold uppercase text-slate-500 tracking-wider">
                    Parked Sale
                  </span>
                </TableCell>
                <TableCell></TableCell>
                <TableCell align="right" className="!p-[7px]"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sales.map((sale, i) => {
                return (
                  <TableRow
                    key={i}
                    hover
                    onClick={() => handleRetrieve(sale.id)}
                    className="cursor-pointer"
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      <div className="flex gap-[15px]">
                        <div>
                          <img
                            src={sale.img ? sale.img : no_img}
                            className="rounded-[10px] h-[60px] w-[60px] object-cover"
                            alt="product_img"
                          />
                        </div>
                        <div className="grid gap-[1px] font-medium">
                          {sale.parkItems[0] && (
                            <span>
                              {sale.parkItems[0].prod &&
                                `${sale.parkItems[0].qty} x ${sale.parkItems[0].prod.name}`}
                            </span>
                          )}
                          {sale.parkItems[1] && (
                            <span>
                              {sale.parkItems[1].prod &&
                                `${sale.parkItems[1].qty} x ${sale.parkItems[1].prod.name}`}
                            </span>
                          )}
                          {sale.parkItems.length > 3 ? (
                            <span>
                              and {sale.parkItems.length - 2} more products
                            </span>
                          ) : (
                            sale.parkItems[2] && (
                              <span>
                                {sale.parkItems[2].prod &&
                                  `${sale.parkItems[2].qty} x ${sale.parkItems[2].prod.name}`}
                              </span>
                            )
                          )}
                          <span className="text-[12px] text-gray-500">
                            Parked {getTimeDifference(sale.parkDate)} by{" "}
                            {sale.parkUser &&
                              sale.parkUser.firstName +
                                " " +
                                sale.parkUser.lastName}
                          </span>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell className="min-w-[280px]">
                      <div className="grid gap-2 text-gray-500">
                        {sale.customer && (
                          <div className="flex gap-2">
                            <span className="font-medium">Customer: </span>
                            <span>
                              {sale.customer.firstName +
                                " " +
                                sale.customer.lastName}
                            </span>
                          </div>
                        )}
                        {sale.note && (
                          <div className="flex gap-1">
                            <span className="font-medium mr-[35px]">
                              Note:{" "}
                            </span>
                            <span className="max-w-[280px] whitespace-pre-line">
                              {sale.note}
                            </span>
                          </div>
                        )}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div className="flex !flex-row-reverse">
                        <IconButton color="primary">
                          <ReplayRounded />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className="p-[20px]">
          <span className="text-[20px] text-gray-500">No park sale</span>
        </div>
      )}
    </div>
  );
};

export default RetrieveSales;
